<template>
  <div class="platform-code-view">
    <h2 class="platform-title">平台类目管理</h2>

    <div class="toolbar">
      <el-button type="primary" @click="fetchPlatformCodes" :loading="loading">
        <el-icon><Refresh /></el-icon>
        刷新分类树
      </el-button>
    </div>

    <!-- 完全还原原代码的多层嵌套结构 -->
    <el-collapse v-model="activeNames">
      <!-- 一级类目 -->
      <el-collapse-item
        v-for="category in platformCodes.filter(cat => cat.level === 1)"
        :key="category.catID"
        :title="category.name"
        :name="category.catID"
        class="category-item level-1"
      >
        <!-- 二级类目 -->
        <el-collapse v-model="activeNames">
          <el-collapse-item
            v-for="subCategory in category.children"
            :key="subCategory.catID"
            :title="subCategory.name"
            :name="subCategory.catID"
            class="category-item level-2"
          >
            <!-- 三级类目 -->
            <el-collapse v-model="activeNames">
              <el-collapse-item
                v-for="subSubCategory in subCategory.children"
                :key="subSubCategory.catID"
                :title="subSubCategory.name"
                :name="subSubCategory.catID"
                class="category-item level-3"
              >
                <!-- 四级类目 -->
                <el-collapse v-model="activeNames">
                  <el-collapse-item
                    v-for="subSubSubCategory in subSubCategory.children"
                    :key="subSubSubCategory.catID"
                    :title="subSubSubCategory.name"
                    :name="subSubSubCategory.catID"
                    class="category-item level-4"
                  />
                </el-collapse>
              </el-collapse-item>
            </el-collapse>
          </el-collapse-item>
        </el-collapse>
      </el-collapse-item>
    </el-collapse>

    <el-empty v-if="!platformCodes.length && !loading" description="暂无分类数据" />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { ElButton, ElCollapse, ElCollapseItem, ElEmpty } from 'element-plus'
import { Refresh } from '@element-plus/icons-vue'
import request from '@/utils/axios'   // v2.1 唯一入口

const platformCodes = ref([])
const loading = ref(false)
const activeNames = ref([])

// 获取数据
const fetchPlatformCodes = async () => {
  loading.value = true
  try {
    const res = await request.get('/platformcode/')
    const data = res?.data || res || (Array.isArray(res) ? res : [])
    platformCodes.value = Array.isArray(data) ? data : []
  } catch (error) {
    console.error('获取平台类目失败:', error)
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  fetchPlatformCodes()
})
</script>

<style scoped>
.platform-code-view {
  padding: 24px;
  max-width: 1400px;
  margin: 0 auto;
  background: #f8f9fb;           /* 网站一致浅色背景 */
}

.platform-title {
  font-size: 2.25rem;
  font-weight: 700;
  color: #1f2a44;               /* 深色标题 */
  margin-bottom: 24px;
}

.toolbar {
  margin-bottom: 24px;
}

.category-item {
  margin-bottom: 8px;
}

/* 浅色 + 深色字体（无任何荧光效果） */
:deep(.el-collapse-item__header) {
  background: #ffffff;
  color: #1f2a44;
  font-weight: 600;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

:deep(.el-collapse-item__header:hover) {
  background: #f0f4f8;
}

/* 各层级缩进 */
.level-1 { padding-left: 0; }
.level-2 { padding-left: 40px; }
.level-3 { padding-left: 80px; }
.level-4 { padding-left: 120px; }
</style>